export const RECEIVED_DATA = 'RECEIVED_DATA';
export const REMOVED_DATA = 'REMOVED_DATA';

export const BEGIN_REVISIT_ASSESSMENT = 'BEGIN_REVISIT_ASSESSMENT';
export const END_REVISIT_ASSESSMENT = 'END_REVISIT_ASSESSMENT';

export const TOKEN_HAS_EXPIRED = 'TOKEN_HAS_EXPIRED';
export const TOKEN_REFRESHED = 'TOKEN_REFRESHED';



// WEBPACK FOOTER //
// ./src/redux/actions/statusActionTypes.js